import PropTypes from 'prop-types';

const HarvestClient = {
  id: PropTypes.number,
  name: PropTypes.string,
};

export default HarvestClient;
